import { useAuth as o } from "@phx-husky/use-auth";
var t = function t() {
  var t = o();
  return {
    forgotPassword: function forgotPassword(o) {
      return t.forgotPassword(o);
    },
    forgotPasswordSubmit: function forgotPasswordSubmit(o) {
      return t.forgotPasswordSubmit(o);
    },
    validate: function validate(o) {
      return t.validate(o);
    }
  };
};
export { t as useForgotPassword };